import { render, staticRenderFns } from "./CreateCompanyScreen.vue?vue&type=template&id=71283ed8&"
import script from "./CreateCompanyScreen.vue?vue&type=script&lang=js&"
export * from "./CreateCompanyScreen.vue?vue&type=script&lang=js&"
import style0 from "./CreateCompanyScreen.vue?vue&type=style&index=0&id=71283ed8&prod&module=true&lang=scss&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports
import {QForm,QBtn,QInnerLoading,QSpinnerTail} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QForm,QBtn,QInnerLoading,QSpinnerTail})
